module.exports = __webpack_public_path__ + "img/ProxyDriving.69eb07b1.png";